export default __webpack_public_path__ + "images/88e5ffcf8fb8a88550de993c010f81f8-pyxirIcon.svg";